<template>
  <loader v-if="loading"
    :label="$t('conflict.searchingTodos')"
  />
  <v-container
    v-else
  >
    <v-row
      class="white"
      dense
    >
      <v-col
        class="py-0"
      >
        <h3 class="ml-3">{{ $t('scenario.possibleScenario') }}</h3>
        <div class="px-4 py-2">
          <elements
            :scenario="todo.conflict.scenario"
          />
        </div>
      </v-col>
    </v-row>
    <v-row
      class="mt-4 raison-highlight"
      dense
      >
      <v-col class="px-4 py-2">
        <h3>{{ $t("conflict.cohere") }}</h3>
        <div class="text-center">
          <v-btn
            class="raison-btn"
            @click="yesUnionIsPossible"
          >
            {{ $t('conflict.yes') }}
          </v-btn>
          <v-btn
            class="raison-btn"
            @click="noUnionIsImpossible"
          >
            {{ $t('conflict.no') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Elements from '@/components/global/Elements'
import Loader from '@/components/global/Loader'

import conflictService from '@/services/conflicts.js'

export default ({
  name: 'SuggestPossibleScenariosUnion',

  components: {
    Elements,
    Loader,
  },

  mixins: [  ],

  data () {
    return {
      loading: false,
    }
  },

  props: {
    todo: {
      type: Object,
      required: true
    }
  },

  computed: {
  },

  methods: {
    yesUnionIsPossible(){
      // console.log('yesUnionIsPossible')
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict
      conflictService.prefer(projectId, conflictId, {
        resolution: "PossibleScenarioConfirmed",
        todoId: this.todo.id
      })
      .then(response => {
        const todo = response.data
        this.$emit('nextTodo', todo)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] })
      })
      .finally(() => {
        this.loading = false
      });
    },
    noUnionIsImpossible(){
      console.log('noUnionIsImpossible', this.conflict)
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict
      conflictService.prefer(projectId, conflictId, {
        resolution: "NoSense",
        todoId: this.todo.id,
        scenario: this.todo.conflict.combinedScenarios[0],
        combinedScenario: this.todo.conflict.combinedScenarios[1]
      })
      .then(response => {
        const todo = response.data
        this.$emit('nextTodo', todo)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] })
      })
      .finally(() => {
        this.loading = false
      });
    },
  }

})
</script>
<style>
</style>